import { useAddress, useContract } from '@thirdweb-dev/react';
import { useAsync, useAsyncFn } from 'react-use';
import { bigNumberToDecimal } from '@app/helpers/format';
import { useConfig } from '@app/config';

export function usePendingRewardInfo(index: number) {
  const address = useAddress();
  const config = useConfig();
  const { contract: dividendsContract } = useContract(
    config?.CONTRACTS.DIVIDENDS
  );

  const { value, loading: loadingTokenBalance } = useAsync(async () => {
    if (!dividendsContract || !address) {
      return;
    }

    const distributedToken = await dividendsContract.call('distributedToken', [
      index
    ]);

    const pendingDividendsAmount = await dividendsContract.call(
      'pendingDividendsAmount',
      [distributedToken, address]
    );

    return {
      pendingDividendsAmount: bigNumberToDecimal(pendingDividendsAmount, 18),
      distributedToken
    };
  }, [dividendsContract, address, index]);

  const [{ loading: claiming }, claim] = useAsyncFn(async () => {
    if (!dividendsContract) {
      return;
    }

    const distributedToken = await dividendsContract.call('distributedToken', [
      index
    ]);

    return dividendsContract.call('harvestDividends', [distributedToken]);
  }, [dividendsContract]);

  return {
    pendingDividendsAmount: value?.pendingDividendsAmount,
    distributedToken: value?.distributedToken,
    claim,
    claiming
  };
}
